import { EmptyValuePlaceholder } from '@/components/ui'
export default ({children, label, value, labelCss = "", responsiveGridColsCss = ""}) => {
  return (
    <div className={`flex flex-wrap ${responsiveGridColsCss} items-center gap-2`}>
      <div className={`text-gray-600 whitespace-nowrap ${labelCss}`}>{label} :</div>
      <div className="pl-2">
        {value ? value : null }
        { (!value && !children ) && <EmptyValuePlaceholder /> }
        { children }
      </div>
    </div>
  )
}